import PropTypes from "prop-types"
import { connect } from "react-redux"

import { selectIncognito } from "../../Utils/incognito"

import "./styles.less"

// The fixed mask shown in Incognito (Private) mode, matching the Figma: ten U+2217 asterisks.
export const INCOGNITO_MASK = "∗∗∗∗∗∗∗∗∗∗"

// Wraps a sensitive value (money, a KPI figure, an account/member name, an email...) and replaces
// it with the ∗ mask when Incognito mode is on, so the account can be shown on a shared screen or
// in a demo without revealing real numbers. Non-sensitive context (chart shapes, dates, entity
// names, plain counts) is left unwrapped and stays visible.
//
//   <Private>{formatCurrency(amount)}</Private>
//   <Private mask="∗∗∗">{email}</Private>          // custom mask length
//   <Private disabled={someCondition}>{value}</Private>
//
// The mask is wrapped in a span that plays a quick blur-in reveal whenever it mounts (i.e. when
// the user toggles Incognito on, and on each page it opens while on).
//
// Masking is Standard-mode only: `selectIncognito` keeps it off in the admin panel, in Demo /
// External demo mode and during Onboarding, even when the persisted flag is on.
const Private = ({ incognito, disabled, mask, children }) => {
  if (disabled || !incognito) return children ?? null
  return <span className="incognito-mask">{mask || INCOGNITO_MASK}</span>
}

Private.propTypes = {
  incognito: PropTypes.bool,
  disabled: PropTypes.bool,
  mask: PropTypes.string,
  children: PropTypes.node
}

const mapStateToProps = (state) => ({ incognito: selectIncognito(state) })

export default connect(mapStateToProps)(Private)
